import { c as _c } from "react/compiler-runtime";
import { Grid } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { COMPONENT_ID_DESKTOP, COMPONENT_ID_MOBILE, getChildrenHeadings } from './utils';
type Props = StructuredContentDocumentWithRenderer<{
  children: StructuredContentDocument;
}>;
export function CreditCardsTableOfContents(sccProps) {
  const $ = _c(21);
  const {
    props: t0
  } = sccProps;
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== sccProps) {
    t1 = getChildrenHeadings(sccProps);
    $[0] = sccProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contentHeadings = t1;
  if (contentHeadings.length <= 0) {
    let t2;
    if ($[2] !== children) {
      t2 = renderStructuredContent(children);
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <>{t2}</>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: "column",
      md: "row"
    };
    t3 = {
      position: "relative"
    };
    t4 = {
      xs: 5,
      md: 8
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: 12,
      md: 3
    };
    t6 = {
      position: "sticky",
      top: 0,
      zIndex: 2
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== contentHeadings) {
    t7 = <Grid size={t5} sx={t6} component="aside"><Desktop headings={contentHeadings} tocId={COMPONENT_ID_DESKTOP} /><Mobile headings={contentHeadings} tocId={COMPONENT_ID_MOBILE} /></Grid>;
    $[11] = contentHeadings;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      xs: 12,
      md: 9
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== children) {
    t9 = renderStructuredContent(children);
    $[14] = children;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <Grid size={t8}>{t9}</Grid>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <Grid container={true} direction={t2} sx={t3} spacing={t4}>{t7}{t10}</Grid>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}